import {FC, useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import {KeyPerformanceList} from './KeyPerformanceList'
import DateRangePickers from '../../sharedComponent/DateRangePickers/DateRangePickers'
import ProductStatus from './ProductStatus'
import SalesPerformance from './SalesPerformance'
import TpvStatus from './TpvStatus'
import UtilitMix from './UtilitMix'
import {useLazyQuery} from '@apollo/client'
import {GET_TEAMADMIN_DASHBOARD_DATA} from '../../../utils/GraphQLAPI'
import TeamAdminSaleschannelFilter from './TeamAdminSaleschannelFilter'
import moment from 'moment'
import Breadcrumbs from '../../sharedComponent/Breadcrumbs/Breadcrumbs'

const DashboardPage: FC = () => {
  const [productStatus, setProductStatus] = useState<any>()
  const [salesPerformance, setSalesPerformance] = useState<any>()
  const [tpvStatus, setTpvStatus] = useState<any>()
  const [utilityMix, setUtilityMix] = useState<any>()
  const [fromDate, setFromDate] = useState<any>()
  const [toDate, setToDate] = useState<any>()
  const dateFormat = 'YYYY-MM-DD'

  useEffect(() => {
    setFromDate(
      new Date(
        moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
      ).toISOString()
    )

    setToDate(new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString())
    //To get the dashboard data with filters
    getTeamAdminDashboardData({
      variables: {
        teamAdminDashboardInput: {
          saleChannelsIds: null,
          fromDate: new Date(
            moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
          ).toISOString(),
          toDate: new Date(
            moment(moment().toDate()).format(dateFormat) + 'T23:59:00'
          ).toISOString(),
        },
      },
    })
  }, [])

  const [getTeamAdminDashboardData, {loading: reload}] = useLazyQuery(
    GET_TEAMADMIN_DASHBOARD_DATA,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        setProductStatus(data.getTeamAdminDashboard.productStatus)
        setSalesPerformance(data.getTeamAdminDashboard.salesPerformance)
        setTpvStatus(data.getTeamAdminDashboard.tpvStatus)
        setUtilityMix(data.getTeamAdminDashboard.utilityMix)
      },
    }
  )

  //helper function to assign selected date filter
  const getdataFromDateFilter = (objFromDate: any, objToDate: any, objDays: any) => {
    const salesChannelFilter = localStorage.getItem('salesChannelFilter')
      ? localStorage.getItem('salesChannelFilter')
      : null
    setFromDate(objFromDate)
    setToDate(objToDate)
    getTeamAdminDashboardData({
      variables: {
        teamAdminDashboardInput: {
          saleChannelsIds: salesChannelFilter ? JSON.parse(salesChannelFilter) : null,
          fromDate: objFromDate,
          toDate: objToDate,
        },
      },
    })
  }
  //helper fn to assign saleschannel filter
  const teamDashboardFilter = (salesChannelFilterIds: any) => {
    localStorage.removeItem('salesChannelFilter')
    localStorage.setItem(
      'salesChannelFilter',
      JSON.stringify(salesChannelFilterIds?.variables.saleChannelsIds)
    )
    getTeamAdminDashboardData({
      variables: {
        teamAdminDashboardInput: {
          saleChannelsIds: salesChannelFilterIds?.variables.saleChannelsIds,
          fromDate,
          toDate,
        },
      },
    })
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <Breadcrumbs title='Dashboard' subTitle='Home - Dashboard' />

        <div className='d-md-flex w-40 justify-content-evenly align-items-center'>
          <div className='mx-2'>
            <TeamAdminSaleschannelFilter
              getKeyPerformancemetricsData={teamDashboardFilter}
              colors={'white'}
            />
          </div>
          <div className='mx-2'>
            <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'} />
          </div>
        </div>
      </div>
      {/* Dashboard Cards Start */}
      <Row>
        <Col md-6 lg-6 xl-6 mb-md-5 mb-xl-10>
          {/* Utility Card */}
          <UtilitMix utilityMix={utilityMix} reload={reload} />
        </Col>
        <Col md-6 lg-6 xl-6 mb-md-5 mb-xl-10>
          {/* tpv status card */}
          <TpvStatus tpvStatus={tpvStatus} reload={reload} />
        </Col>
      </Row>
      <Row className='mb-5'>
        <Col sm md lg='6'>
          {/* Sales performance Card */}
          <SalesPerformance salesPerformace={salesPerformance} reload={reload} />
        </Col>
        <Col sm md lg='6'>
          {/* product status card */}
          <ProductStatus productStatus={productStatus} reload={reload} />
        </Col>
      </Row>

      <KeyPerformanceList className='card-xxl-stretch mb-5 mb-xl-8' />
    </>
  )
}

const TeamAdminDashboard: FC = () => {
  return (
    <>
      <DashboardPage />
    </>
  )
}

export {TeamAdminDashboard}
